"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyTableHead = exports.StickyTableCell = exports.fontWeight = exports.border = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const mui_1 = require("tss-react/mui");
exports.border = '1px solid #e1e1e1';
exports.fontWeight = 500;
exports.StickyTableCell = (0, mui_1.withStyles)(TableCell_1.default, (theme) => ({
    head: {
        left: 0,
        position: 'sticky',
        align: 'left',
        zIndex: '2',
        backgroundColor: theme.palette.common.white,
    },
    body: {
        left: 0,
        position: 'sticky',
        backgroundColor: theme.palette.common.white,
        minWidth: '450px',
        border: exports.border,
        zIndex: '10',
    },
}));
exports.StickyTableHead = (0, mui_1.withStyles)(TableCell_1.default, (theme) => ({
    head: {
        left: 0,
        position: 'sticky',
        zIndex: '3',
        backgroundColor: theme.palette.common.white,
    },
    body: {
        left: 0,
        position: 'sticky',
        backgroundColor: theme.palette.common.white,
        minWidth: '450px',
        border: exports.border,
        zIndex: '3',
    },
}));
const styles = ({ palette, components }) => ({
    head: {
        minWidth: '150px',
        border: exports.border,
    },
    tableContainer: {
        border: exports.border,
        overflowY: 'auto',
        height: '65vh',
        padding: 0,
    },
    cell: {
        minWidth: '100px',
        border: exports.border,
    },
    cellTotals: {
        bottom: 0,
    },
    cellAmounts: {
        padding: 0,
    },
    viewRolloverWrapper: {
        color: palette.black,
        fontWeight: 600,
        fontSize: 14.5,
        lineHeight: '17px',
    },
    rolloverMainHead: {
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        '& div:last-child': {
            marginLeft: 'auto',
        },
    },
    closeButton: {
        padding: 0,
    },
    rolloverDate: {
        margin: '8px 0',
    },
    rolloverTable: {
        textAlign: 'right',
        fontWeight: 400,
        borderCollapse: 'separate',
        borderSpacing: '0 15px',
        backgroundColor: palette.white,
        '& tr:last-child': {
            boxShadow: 'inset 0px 1px 0px',
            height: 50,
        },
    },
    rollOverOperation: {
        width: 30,
    },
    rollOverName: {
        width: 100,
    },
    rollOverAmounts: {
        width: 120,
        textAlign: 'right',
    },
    rollOverEdit: {
        width: 70,
        color: palette.primary.main,
        fontWeight: 500,
        textAlign: 'center',
    },
    rolloverDatedon: {
        fontSize: 13,
        lineHeight: '15px',
        color: palette.others.titleFaded,
    },
    buttonWrapper: {
        textAlign: 'right',
        marginTop: 5,
    },
    input: {
        color: palette.black,
        paddingBottom: 0,
        paddingTop: 0,
        marginTop: 0,
        fontSize: components.register.fontSize.default,
        width: 100,
        alignItems: 'right',
        '& input': {
            padding: '0 5px',
            fontSize: components.register.fontSize.default,
            border: `1px solid ${components.yearlyBudget.inputBorder}`,
            borderRadius: 5,
            height: 28,
            '&::-ms-clear ': {
                display: 'none',
            },
        },
    },
});
exports.default = styles;
